/*
  JOLI POT, mise à jour en direct de la ligne « Les Jolis Points » (snippets/jp-points.liquid).
  Fiche produit : lit le prix total affiché (bouton du configurateur, carte à planter, ou prix du thème x quantité)
  et recalcule à chaque changement (MutationObserver + événements de saisie).
  Panier : écoute « cart:change » du thème (cart.total_price, après remises, hors livraison).
*/
(function () {
  if (window.jpPointsPret) return;
  window.jpPointsPret = true;

  function euros(txt) {
    var s = String(txt || '').replace(/[^\d.,]/g, '');
    if (!s) return null;
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (!/\.\d{1,2}$/.test(s)) s = s.replace(/\./g, '');
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function ecrire(el, pts) {
    if (pts === null) return;
    pts = Math.max(0, Math.floor(pts + 1e-6));
    var nb = el.querySelectorAll('[data-jp-points-nb]');
    for (var i = 0; i < nb.length; i++) if (nb[i].textContent !== String(pts)) nb[i].textContent = String(pts);
    var cacher = pts < 1;
    if (el.hidden !== cacher) el.hidden = cacher;
  }

  /* Prix total affiché sur la fiche, en euros */
  function prixFiche(el) {
    var portee = el.closest('.shopify-section') || document;
    var b = portee.querySelector('form.jp-produit-form .ProductForm__AddToCart [data-money-convertible]') || document.querySelector('form.jp-produit-form .ProductForm__AddToCart [data-money-convertible]');
    if (b && euros(b.textContent) !== null) return euros(b.textContent);
    var k = portee.querySelector('[data-jpk-total]') || document.querySelector('[data-jpk-total]');
    if (k) return euros(k.textContent);
    var t = portee.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
    if (t) return euros(t.textContent);
    var zone = el.closest('product-rerender') || portee;
    var p = zone.querySelector('.price-list--product sale-price');
    if (!p) return null;
    var clone = p.cloneNode(true), sr = clone.querySelector('.sr-only');
    if (sr) sr.remove();
    var u = euros(clone.textContent);
    if (u === null) return null;
    var q = zone.querySelector('input[name="quantity"]');
    var n = q ? (parseInt(q.value, 10) || 1) : 1;
    return u * n;
  }

  var attente = false;
  function majFiches() {
    attente = false;
    var els = document.querySelectorAll('.jp-points[data-jp-points="produit"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], a = el.getAttribute('data-jp-points-ancre'), cible = null;
      /* ancre : sélecteurs séparés par « || », le premier trouvé gagne (ex. encadré livraison, sinon bouton) */
      if (a) {
        var liste = a.split('||');
        for (var k = 0; k < liste.length && !cible; k++) cible = document.querySelector(liste[k].trim());
        /* Rangée dans la note « bon à savoir » (jp-note-achat.js) : on ne la déplace plus */
        if (cible && cible.nextElementSibling !== el && !el.closest('[data-jp-note-achat]')) cible.parentNode.insertBefore(el, cible.nextSibling);
      }
      ecrire(el, prixFiche(el));
      /* Configurateur : la ligne suit le bouton d'ajout (masqué tant que les étapes ne sont pas remplies) */
      var bp = cible && cible.closest ? (cible.closest('form') || document).querySelector('.ProductForm__AddToCart') : null;
      if (bp && !el.hidden && (bp.classList.contains('jp-cache') || bp.offsetParent === null)) el.hidden = true;
    }
  }
  function plusTard() {
    if (attente) return;
    attente = true;
    (window.requestAnimationFrame || setTimeout)(majFiches);
  }

  function demarrer() {
    if (document.querySelector('.jp-points[data-jp-points="produit"]')) {
      majFiches();
      if (window.MutationObserver) {
        new MutationObserver(function (liste) {
          for (var i = 0; i < liste.length; i++) {
            var c = liste[i].target;
            var el = c.nodeType === 1 ? c : c.parentNode;
            if (el && el.closest && (el.closest('.jp-points') || el.closest('.jp-ap') || el.closest('.jpna__ligne[data-jpna="points"]'))) continue;
            plusTard();
            return;
          }
        }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'style', 'disabled'] });
      }
      document.addEventListener('input', plusTard, true);
      document.addEventListener('change', plusTard, true);
      document.addEventListener('click', function () { setTimeout(plusTard, 60); }, true);
      document.addEventListener('variant:change', plusTard);
    }
  }

  document.addEventListener('cart:change', function (e) {
    var c = e && e.detail && e.detail.cart;
    if (!c) return;
    var els = document.querySelectorAll('.jp-points[data-jp-points="panier"]');
    for (var i = 0; i < els.length; i++) {
      if (!c.item_count) { els[i].hidden = true; continue; }
      ecrire(els[i], (c.total_price || 0) / 100);
    }
  });

  /* 28/10/2026 : « En savoir + » ouvre sous la ligne une bulle qui résume le programme (modèle <template data-jp-points-bulle> du snippet),
     au lieu d'emmener sur la page ; la page s'ouvre dans un nouvel onglet depuis la bulle. Un 2e clic ou la croix referme la bulle. */
  document.addEventListener('click', function (e) {
    var t = e.target, x = t.closest && t.closest('[data-jp-points-fermer]');
    if (x) { var bx = x.closest('.jp-points-bulle'), l = bx && bx.previousElementSibling, al = l && l.querySelector('[data-jp-points-lien]'); if (al) al.setAttribute('aria-expanded', 'false'); if (bx) bx.remove(); if (al) al.focus({ preventScroll: true }); return; }
    var a = t.closest && t.closest('.jp-points a[href], [data-jpna="points"] a[href]');
    if (!a || a.closest('.jp-points-bulle')) return;
    var tpl = document.querySelector('template[data-jp-points-bulle]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    e.preventDefault();
    var ligne = a.closest('.jp-points, [data-jpna="points"]') || a.parentNode, suiv = ligne.nextElementSibling;
    if (suiv && suiv.classList.contains('jp-points-bulle')) { suiv.remove(); a.setAttribute('aria-expanded', 'false'); return; }
    var b = tpl.content.firstElementChild.cloneNode(true), p = b.querySelector('[data-jp-points-page]');
    if (p) p.href = a.href;
    ligne.insertAdjacentElement('afterend', b);
    a.setAttribute('aria-expanded', 'true');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
